import React, { useState, useEffect, useRef } from "react";
import "./InputSearch.css";
import ItemHistoric from "../CRM/ItemHistoric";
import ButtonIcon from "./ButtonIcon";

export default function InputSearch (props)
{
    const [focused, setFocused] = useState(false);
    const [internalValue, setInternalValue] = useState(props.value || "");
    const onChangeRef = useRef(props.onChange);
    
    useEffect(() => {
        onChangeRef.current = props.onChange;
    }, [props.onChange]);
    
    useEffect(() => {
        const handler = setTimeout(() => {
            onChangeRef.current({ target: { value: internalValue } });
        }, 500);
        
        return () => {
            clearTimeout(handler);
        };
    }, [internalValue]);
    
    function getStyleFocus ()
    {
        return focused ? "yesFocus" : "noFocus";
    }
    
    function handleFocus (focused)
    {
        setFocused(focused);
    }
    
    return (
        <div className="inputSearch">
            <i className={`far fa-search icon ${getStyleFocus()}`}></i>
            <input
                className={`${internalValue !== "" ? "activeHistoricSearch" : ""} field ${getStyleFocus()}`}
                onBlur={() => handleFocus(false)}
                onMouseUp={() => handleFocus(true)}
                onChange={(e) => setInternalValue(e.target.value)}
                value={internalValue}
                placeholder={props.placeholder}
            />
            {
                internalValue !== "" &&
                <div className={`historicSearch ${getStyleFocus()} animateSlideDown`}>
                    {
                        props.data.map((e, i) => (
                            <ItemHistoric
                                key={i}
                                data={e}
                                permissions={props.permissions}
                                onSelectItem={props.onSelectItem}
                            />
                        ))
                    }
                    {
                        !props.searching && props.data.length === 0 &&
                        <div className="noContentInputSearch">
                            opsssss, não encontramos nada por aqui
                        </div>
                    }
                    {
                        props.searching && [1, 2].map((v, i) => {
                            return (
                                <div className="row no-gutters itemHistoric" key={i}>
                                    <div className="col-2 colItemHistoric">
                                        <div className="skeletonCircleInputSearch"></div>
                                    </div>
                                    <div className="col-10 colItemHistoric detailsItemHistoric">
                                        <div className="skeletonLineInputSearch short"></div>
                                        <div className="skeletonLineInputSearch short"></div>
                                        <div className="skeletonLineInputSearch short"></div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }
            {
                internalValue !== "" &&
                <ButtonIcon
                    icon="fal fa-times"
                    onClick={() => {
                        setInternalValue("");
                        props.onClearInputSearch();
                    }}
                    className="buttonIcon"
                />
            }
        </div>
    );
}